var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16927 9.16602V5.83268C5.16927 4.72761 5.60826 3.66781 6.38966 2.8864C7.17106 2.105 8.23087 1.66602 9.33594 1.66602C10.441 1.66602 11.5008 2.105 12.2822 2.8864C13.0636 3.66781 13.5026 4.72761 13.5026 5.83268V9.16602M3.5026 9.16602H15.1693C16.0897 9.16602 16.8359 9.91221 16.8359 10.8327V16.666C16.8359 17.5865 16.0897 18.3327 15.1693 18.3327H3.5026C2.58213 18.3327 1.83594 17.5865 1.83594 16.666V10.8327C1.83594 9.91221 2.58213 9.16602 3.5026 9.16602Z",
    stroke: "#00C7BE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIco);
export default __webpack_public_path__ + "static/media/lockIco.87da58bf512a0f0afe777823ebea0a7c.svg";
export { ForwardRef as ReactComponent };